import { Ajax } from './axios';
// 报名
export default {
  // 分页获取批次列表
  enrollBatchPagePOST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/enroll/batch/page', { ...param });
  },
  // 获取报名点列表（第一步提交）
  enrollListAgentPOST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/enroll/listAgent', { ...param });
  },
  // 获取等级考级报考详情（第一步提交）
  getEnrollListSubjectGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/listSubjectGroup/${param.gradeId}`);
  },
  // 提交报考科目信息（第一步提交）
  commitSubjectEnrollPOST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/enroll/commitSubjectEnroll', { ...param });
  },
  // 提交报考考级信息（第二步提交）
  commitExamEnrollPOST (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/enroll/commitExamEnroll', { ...param });
  },
  // 获取报考信息详情（第二步提交）
  getEnrollConfigGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/getEnrollConfig/${param.gradeAgentId}`);
  },
  // 获取等级考级列表
  getEnrollListGradeGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/listGrade/${param.specialtyId}`);
  },
  // 获取分类专业列表
  getEnrollListSpecialtyGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/listSpecialty/${param.batchId}`);
  },
  // 校验是否可报名当前考级 /{version}/enroll/checkEnroll/{gradeId}
  enrollCheckEnrollGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/checkEnroll/${param.gradeId}`);
  },
  // 获取提交的考级信息
  enrollDetailGET (param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/enrollDetail/${param.examId}`);
  }
};
